import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class AstronomerHideout1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ASTRONOMER_HIDEOUT1;
}

export default AstronomerHideout1PoiTileEntity;
